/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import Styles from './Home24ConteComSantander.css';
import RedButton from '@/components/atoms/RedButton';

function Home24ConteComSantander() {
  return (
    <section id="conte-com-santander">
      <ContainerHome24>
        <div className="conte-com-santander-contain">
          <picture>
            <source type="image/webp" srcSet="assets/home24/img-conte-com-santander-desk.webp" />
            <source type="image/png" srcSet="assets/home24/img-conte-com-santander-desk.png" />
            <img
              src="assets/home24/img-conte-com-santander-desk.png"
              alt="Celular com oferta de carros a venda e uma chama do Santander de fundo."
              className="img-conte-com-santander-desk"
            />
          </picture>
          {/* <img
            src="assets/home24/img-conte-com-santander-desk.png"
            alt=" Celular com oferta de carros a venda e uma chama do Santander de fundo."
            className="img-conte-com-santander-desk"
          /> */}
          <div className="conte-com-santander-conteudo">
            <h3 className="conte-com-santander-title">
              Conte com a Santander Financiamentos para comprar seu novo veículo!
            </h3>
            <picture>
              <source type="image/webp" srcSet="assets/home24/img-conte-com-santander-desk.webp" />
              <source type="image/png" srcSet="assets/home24/img-conte-com-santander-desk.png" />
              <img
                src="assets/home24/img-conte-com-santander-desk.png"
                alt="Celular com oferta de carros a venda e uma chama do Santander de fundo."
                className="img-conte-com-santander"
              />
            </picture>
            {/* <img
              src="assets/home24/img-conte-com-santander-desk.png"
              alt=" Celular com oferta de carros a venda e uma chama do Santander de fundo."
              className="img-conte-com-santander"
            /> */}
            <p className="conte-com-santander-text">
              Em poucos passos você simula o financiamento e envia a proposta. A Santander
              Financiamentos ajuda você a conquistar esse sonho!
            </p>
            <div className="conte-com-santander-topico">
              <img src="assets/home24/ic_bank_transactions.svg" alt="" className="" />
              <p className="conte-com-santander-text">
                Mais de <b>800 mil</b> veículos financiados por ano.
              </p>
            </div>
            <div className="conte-com-santander-topico">
              <img src="assets/home24/ic_internet_banking.svg" alt="" className="" />
              <p className="conte-com-santander-text">
                Mais de <b>60 anos</b> de experiência em financiamento de veículos.
              </p>
            </div>
            <div className="conte-com-santander-topico">
              <img src="assets/home24/ic_career_agile.svg" alt="" className="" />
              <p className="conte-com-santander-text">
                Mais de <b>32 milhões</b> de sonhos realizados com o financiamento Santander.
              </p>
            </div>
            <RedButton
              href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?ori=SF&int_source=home-conte-com-santander#/simulacao"
              id="conte-com-santander-button"
              wide
              target="_blank"
            >
              Simular financiamento
            </RedButton>
          </div>
        </div>
        <div className="elipses" />
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default Home24ConteComSantander;
